import { ReactComponent as SuccessIcon } from '../../../../../icons/successNotify.svg'
import { ReactComponent as CloseIcon } from '../../../../../icons/closeIcon.svg'
import styles from './Notification.module.scss'
import React from 'react'

export const Notification = ({ onClose }) => {
  return (
    <div className={styles.container} data-testid="notification-container">
      <div
        className={styles.close}
        onClick={onClose}
        data-testid="notification-close"
      >
        <CloseIcon />
      </div>
      <div className={styles.header} data-testid="notification-header">
        <div className={styles.left} data-testid="notification-left">
          <div className={styles.iconContainer} data-testid="notification-icon">
            <SuccessIcon />
          </div>
          <div className={styles.description}>УСПЕШНО</div>
        </div>
      </div>
      <span
        className={styles.title}
        data-testid="notification-message"
      >
        Товар добавлен в корзину!
      </span>
    </div>
  )
}
